import './loaderScreen.css'

const LoaderScreen = () => {
    return (
        <div className={'loader-screen'}>
            <i className="fas fa-hamburger loader-screen-icon"/>
        </div>
    )
}

export default LoaderScreen;